import { __decorate, __param, __metadata, __awaiter } from '../../_virtual/_tslib.js';
import { HttpClient } from '@hub-la/fe-core-http-client';
import { inject } from 'inversify';
import { GetAssetSignedUrl } from './get-asset-signed-url.js';
import { UploadAssetBySignedUrl } from './upload-asset-by-signed-url.js';

let SaveAsset = class SaveAsset {
  constructor(httpClient, onUploadProgres) {
    this.httpClient = httpClient;
    this.onUploadProgres = onUploadProgres;
  }
  execute(payload) {
    return __awaiter(this, void 0, void 0, function* () {
      const signedURL = yield new GetAssetSignedUrl(this.httpClient).execute(payload);
      const data = yield new UploadAssetBySignedUrl().execute({
        asset: signedURL.asset,
        file: payload.file,
        writeUrl: signedURL.writeUrl,
        mimeType: payload.mimeType,
        onUploadProgress: this.onUploadProgres
      });
      return data;
    });
  }
};
SaveAsset = __decorate([__param(0, inject(HttpClient)), __metadata("design:paramtypes", [HttpClient, Function])], SaveAsset);

export { SaveAsset };
